module.exports = __webpack_public_path__ + "assets/img/detection.d276fb69.svg";